import { FormattedMessagingTemplateConfiguration } from "@idw-types/data/messaging-template";

export enum MessagingTemplatesActionTypes {
    // Messaging Templates
    SET_MESSAGING_TEMPLATES_LOADING = "SET_MESSAGING_TEMPLATES_LOADING",
    SET_MESSAGING_TEMPLATES = "SET_MESSAGING_TEMPLATES",
    ADD_MESSAGING_TEMPLATE = "ADD_MESSAGING_TEMPLATE"
}

// Messaging Templates
type SetMessagingTemplatesLoadingAction = {
    type: MessagingTemplatesActionTypes.SET_MESSAGING_TEMPLATES_LOADING,
    payload: { isLoading: boolean; }
};

export const setMessagingTemplatesLoading = (isLoading: boolean): SetMessagingTemplatesLoadingAction => ({
    type: MessagingTemplatesActionTypes.SET_MESSAGING_TEMPLATES_LOADING,
    payload: { isLoading }
});

type SetMessagingTemplatesAction = {
    type: MessagingTemplatesActionTypes.SET_MESSAGING_TEMPLATES,
    payload: { axnMessagingTemplates: Array<FormattedMessagingTemplateConfiguration>; }
}

export const setMessagingTemplates = (axnMessagingTemplates: Array<FormattedMessagingTemplateConfiguration>): SetMessagingTemplatesAction => ({
    type: MessagingTemplatesActionTypes.SET_MESSAGING_TEMPLATES,
    payload: { axnMessagingTemplates }
});

type AddMessagingTemplateAction = {
    type: MessagingTemplatesActionTypes.ADD_MESSAGING_TEMPLATE;
    payload: { messagingTemplate: FormattedMessagingTemplateConfiguration };
};

export const addMessagingTemplate = (messagingTemplate: FormattedMessagingTemplateConfiguration): AddMessagingTemplateAction => ({
    type: MessagingTemplatesActionTypes.ADD_MESSAGING_TEMPLATE,
    payload: { messagingTemplate }
});

export type MessagingTemplatesActions =
    // Messaging Templates
    SetMessagingTemplatesLoadingAction |
    SetMessagingTemplatesAction |
    AddMessagingTemplateAction